import produce from "immer";
import {
  FETCH_HUBBLOG,
  FETCH_HUBBLOG_FAILURE,
  FETCH_HUBBLOG_SUCCESS,
  //
  ADD_HUBBLOG,
  ADD_HUBBLOG_SUCCESS,
  ADD_HUBBLOG_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  EDIT_HUBBLOG,
  EDIT_HUBBLOG_SUCCESS,
  EDIT_HUBBLOG_FAILURE,
  //
  DELETE_HUBBLOG,
  DELETE_HUBBLOG_SUCCESS,
  DELETE_HUBBLOG_FAILURE,
  //
  UPLOAD_MEDIA,
  UPLOAD_MEDIA_SUCCESS,
  UPLOAD_MEDIA_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingHubBlogs: false,
  hubBlogList: [],
  isAdding: false,
  isFetchingData: false,
  currentHubBlog: {},
  isUpdating: false,
  isDeleting: false,
  isUploading: false,
};

const HubBlogReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_HUBBLOG:
        draft.isFetchingHubBlogs = true;
        draft.hubBlogList = [];
        break;
      case FETCH_HUBBLOG_SUCCESS:
        draft.isFetchingHubBlogs = false;
        draft.hubBlogList = action.payload;
        break;
      case FETCH_HUBBLOG_FAILURE:
        draft.isFetchingHubBlogs = false;
        draft.hubBlogList = [];
        break;

      case ADD_HUBBLOG:
        draft.isAdding = true;
        break;
      case ADD_HUBBLOG_SUCCESS:
        draft.isAdding = false;
        break;
      case ADD_HUBBLOG_FAILURE:
        draft.isAdding = false;
        break;

      case GET_VIEW_DATA:
        draft.isFetchingData = true;
        draft.currentHubBlog = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetchingData = false;
        draft.currentHubBlog = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetchingData = false;
        draft.currentHubBlog = {};
        break;

      case EDIT_HUBBLOG:
        draft.isUpdating = true;
        break;
      case EDIT_HUBBLOG_SUCCESS:
        draft.isUpdating = false;
        break;
      case EDIT_HUBBLOG_FAILURE:
        draft.isUpdating = false;
        break;

      case DELETE_HUBBLOG:
        draft.isDeleting = true;
        break;
      case DELETE_HUBBLOG_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_HUBBLOG_FAILURE:
        draft.isDeleting = false;
        break;

      case UPLOAD_MEDIA:
        draft.isUploading = true;
        break;
      case UPLOAD_MEDIA_SUCCESS:
        draft.isUploading = false;
        break;
      case UPLOAD_MEDIA_FAILURE:
        draft.isUploading = false;
        break;

      default:
        return state;
    }
  });

export default HubBlogReducer;
